var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSenaiIted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 291.798,
    height: 36.031,
    viewBox: "0 0 291.798 36.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f2f3f7;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    className: "cls-1",
    width: 103.798,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(-121 -49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(-1715 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGOTIPO_SENAI_NOVO",
    "data-name": "LOGOTIPO SENAI_NOVO",
    transform: "translate(1835.9 50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    className: "cls-2",
    d: "M28.4,2.1,27.4,8a1.063,1.063,0,0,1-1,.9h-.1c-1.9-.1-7.2-.6-10.6-.6s-2.7.4-2.7,2,.5,1.1,2.1,2l5.8,3.4c3.4,2,4.7,4.6,4.7,7.9,0,8.8-7.4,12.4-15.4,12.4S3.3,35.5.9,34.8A.86.86,0,0,1,.1,34h0l1-5.9a1.018,1.018,0,0,1,1.1-.9h0c1.9.2,6.9.7,9.4.7s3.4-.7,3.4-2.8-.5-1.2-1.8-2.1L7.1,19A9.459,9.459,0,0,1,3,11.2C3.1,2.5,9.7,0,17.2,0s8.6.6,10.5,1.2a.773.773,0,0,1,.7.8h0v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    className: "cls-2",
    d: "M55.2,1.5l-1,5.8c0,.5-.6.9-1.1.9H43.6c-1.7,0-2.4.6-2.7,2.4L40.3,14H51.9a.736.736,0,0,1,.8.8h0c0,.1-1,5.7-1,5.7,0,.5-.6.9-1.1.9H39l-.7,3.9v1c0,1.1.6,1.4,1.9,1.4h9.5a.736.736,0,0,1,.8.8h0c0,.1-1,5.9-1,5.9,0,.6-.5.8-1.1,1a72.473,72.473,0,0,1-9.3.6c-4.6,0-10.6-2-10.6-8.2s.1-1.5.2-2.4l2.6-14.8C33,1,38.6,0,45.3,0s7.5.3,9.2.6a.736.736,0,0,1,.8.8v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    className: "cls-2",
    d: "M88.7,1.4,83,33.8a2.232,2.232,0,0,1-2.1,1.8H75a1.879,1.879,0,0,1-1.8-1.3l-7-15.8a.42.42,0,0,0-.4-.4c-.1,0-.2.1-.3.4L62.7,34.6c0,.5-.6.9-1.1.9H54.5a.736.736,0,0,1-.8-.8h0L59.4,2.2A2.344,2.344,0,0,1,61.5.4h5.8c.9,0,1.3.6,1.7,1.4l7.2,16.3c0,.3.2.4.3.4s.3,0,.3-.4L79.7,1.4c0-.5.6-.9,1.1-.9h7.1a.736.736,0,0,1,.8.8v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    className: "cls-2",
    d: "M115.6,35.5h-8a.817.817,0,0,1-.8-.9V28H98.2l-2.5,6.6a1.273,1.273,0,0,1-1.1.9H86.2c-.4,0-.7-.2-.7-.6v-.4L96.9,5.6C99,1,102.7,0,107.2,0s7.9.9,8.1,5.6l1.2,28.9h0a.923.923,0,0,1-.9,1Zm-9.2-27c0-.4,0-.7-.4-.7s-.5.2-.6.7l-4.4,12h5.7l-.2-12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    className: "cls-2",
    d: "M135,1.4a.729.729,0,0,0-.8-.9h-7.8a1.172,1.172,0,0,0-1.1.9l-1.5,8.4,10.5-4.9.6-3.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    className: "cls-2",
    d: "M123.2,13.5l-3.7,21.1c0,.5.2,1,.8,1h7.8a1.028,1.028,0,0,0,1.1-1l4.6-26-10.5,4.9h-.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(309 49.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33-2",
    "data-name": "Grupo 33",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    className: "cls-1",
    d: "M24.7.9a.716.716,0,0,0-.8-.9H16.062a1.1,1.1,0,0,0-1.1.9L13.472,9.331,24.1,4.383,24.729.9Z",
    transform: "translate(-8.998 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    className: "cls-1",
    d: "M3.776,31.481.023,52.734a.773.773,0,0,0,.561.939.759.759,0,0,0,.2.024H8.624a1.085,1.085,0,0,0,1.162-.963L14.435,26.5,3.809,31.448Z",
    transform: "translate(0 -17.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    className: "cls-1",
    d: "M88.467,2.728,87.4,8.7a1.176,1.176,0,0,1-1.129.9H79.3L74.72,35.669a1.205,1.205,0,0,1-1.129.93H65.953a.731.731,0,0,1-.764-.7c0-.023,0-.045,0-.068v-.2L69.772,9.568H62.665a.724.724,0,0,1-.794-.646.7.7,0,0,1,0-.118V8.672l1.063-5.977a1.129,1.129,0,0,1,1.063-.9H87.571a.789.789,0,0,1,.83.746v.151Z",
    transform: "translate(-41.323 -1.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    className: "cls-1",
    d: "M166.3,1.794l-1,5.712a1.205,1.205,0,0,1-1.129.93h-9.464c-1.694,0-2.325.565-2.657,2.325l-.6,3.42h11.523a.767.767,0,0,1,.8.737c0,.02,0,.041,0,.06v.133l-1,5.512a1.162,1.162,0,0,1-1.063.93H150.2s-.8,4.549-.8,4.815c0,1.063.565,1.395,1.926,1.395h9.464a.767.767,0,0,1,.8.737c0,.02,0,.041,0,.06v.133L160.558,34.4a1.106,1.106,0,0,1-1.063.93,68.209,68.209,0,0,1-9.232.565c-4.549,0-10.113-1.971-10.493-8.1-.042-.668,2.823-17.1,2.823-17.1C144.22,1.229,149.832.2,156.44.2s7.405.332,9.132.565c.5.033.764.266.764.764v.2Z",
    transform: "translate(-93.356 -0.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    className: "cls-1",
    d: "M249.225,20.819c-1.86,10.726-7.737,15.242-17.932,15.242s-8.235-.365-10.593-.8c-.8-.133-1.229-.465-1.229-1.262s0-.332.033-.565l5.38-30.418a1.934,1.934,0,0,1,1.826-1.826A67.425,67.425,0,0,1,237.569.4c7.87,0,12.933,4.085,12.818,11.689-.023,1.49-1.162,8.734-1.162,8.734M236.174,8.565c-.6,0-2.324.033-2.657.033L230.1,27.925c.332.033,2.059.033,2.657.033,3.752,0,5.911-1.494,6.874-7.173,0,0,1.158-7.067,1.162-8.036,0-3.387-1.627-4.217-4.616-4.217Z",
    transform: "translate(-146.591 -0.263)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSenaiIted);
export default __webpack_public_path__ + "static/media/logo - senai-ited.14dcba6f0f15434682cd9d7174774075.svg";
export { ForwardRef as ReactComponent };